import { Component, ViewEncapsulation, OnInit, Inject, Output, EventEmitter, OnDestroy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionService } from '../../services/subscription.service';

@Component({
  selector: 'app-product-dialog',
  templateUrl: './product-dialog.component.html',
  styleUrls: ['./product-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProductDialogComponent implements OnInit, OnDestroy {
  public config: SwiperConfigInterface = {};
  imageUrl = environment.imageUrl;
  storeDetails = {};
  storeDetailsJson = {};
  storeCurrency = null;
  sub;
  productTabs = [];
  productDescription: string;

  constructor(public apiService:ApiService, 
    private subscriptionService: SubscriptionService,
    private activatedRoute: ActivatedRoute,
    public dialogRef: MatDialogRef<ProductDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public product) { }

  ngOnInit() {
    let sessionStoreData = sessionStorage.getItem('store');
    if(!!sessionStoreData) {
      this.storeCurrency = JSON.parse(sessionStoreData)['currency'];
    }else {
      this.storeCurrency = "$";
    }
    this.getStore();
    this.manipulateProductDesc(this.product);
    // this.product['images'] = [{medium: this.product['product']['product_image1']}]
    // if(!!this.product['product']['product_image2'] && this.product['product']['product_image2'] !== "null") {
    //   this.product['images'][1] = {medium: this.product['product']['product_image2']};
    // }
    this.product['images'] = !!this.product['product']['product_image1']  && !!this.product['product']['product_image2'] ?  [{medium: this.product['product']['product_image1'] }, {medium: this.product['product']['product_image2'] }] : 
    !!this.product['product']['product_image1'] && !!this.product['product']['product_image2'] === false? [{medium: this.product['product']['product_image1'] }] : 
    !!this.product['product']['product_image1'] === false && !!this.product['product']['product_image2']  ? [{medium: this.product['product']['product_image2'] }] :   [{medium: ''}];
    
    this.sub = this.subscriptionService.getSubject().subscribe(message => {
      if(message['closeProducDialog'] ) {
        this.dialogRef.close();
      }
    })
  }

  ngAfterViewInit(){
    this.config = {
      slidesPerView: 1,
      spaceBetween: 0,         
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,        
      loop: false,
      preloadImages: false,
      lazy: true, 
      effect: "fade",
      fadeEffect: {
        crossFade: true
      }
    }
  }
  ngOnDestroy() {
    if(this.sub) {
      this.sub.unsubscribe();
    }
  }
  public close(): void {
    this.dialogRef.close();
  }
  getStore() {
    this.apiService.getStoreDetails().subscribe(result => {
      if(result['response']['status'] === 1) {
        this.storeDetails = result['response']['data']['store'];
        this.storeDetailsJson = result['response']['data']['store_json'];
      }
   
    }, (error) => {
      console.log(error);
    });
  }

  manipulateProductDesc(product: any): void{
    const parser = new DOMParser();
    // Product Description 
    const doc2 = parser.parseFromString(product['product']['website_description'], 'text/html');
    const doc = parser.parseFromString(product['product']['website_description'], 'text/html');
    if (doc){
      doc.querySelectorAll('[role="tab"]').forEach(tabheader => {
      var Tabid=tabheader.getAttribute('aria-controls');
          this.productTabs.push({
            'header' : tabheader.innerHTML,
            'Tabid' : Tabid
          })
      }); 
      if(this.productTabs.length>0){
        this.productTabs.forEach((tabbody, key) => { 
          var TabContent=doc.getElementById(tabbody.Tabid.toString()).innerHTML;
          this.productTabs[key]['TabContent']=TabContent;
        });
        var HtmlDiv = doc2.querySelector('[role="tabpanel"]');
        HtmlDiv.remove();
      }
      this.productDescription = doc2.body.textContent ? doc2.body.textContent : "";
    }
  }

}